import React, { useState, useEffect, useRef } from "react";

import { Row, Col, Card, CardBody, Spinner } from "reactstrap";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation, useNavigate } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
import Lightbox from "react-image-lightbox";
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import { QRCodeSVG } from "qrcode.react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import LocationPicker from "react-location-picker";
import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import UserOrderTable from "pages/UserManagement/UserOrderTable";
import DeliveryAgents from "components/Modal/DeliveryAgents";
// import { useNavigate } from "react-router-dom";


export default function UserManageOrderDetails() {
  const location = useLocation();
  const _id = useParams();
  const [orderId, setOrderId] = useState({});
  const state = location.state?.row;
  const [userAllDetails, setuserAllDetails] = useState({});
  const [orderData, setUserOrderData] = useState({});
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [assingDeliveryModalData, setAssingDeliveryData] = useState({});

  // const navigate = useLocation()

  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const [selectedWarehouses, setSelectedWarehouses] = useState([]);


  // const handleWarehouseClick = (item) => {
  //   if (item.totalRemainingQuantity === 0) {
  //     navigate(`/manufacturers-details/${item?.manufacturer?._id}`);
  //   } else {
  //     setSelectedWarehouses(item.warehouses || []);
  //     setShowWarehouseModal(true);
  //   }
  // };


    const history = useHistory();

  const handleWarehouseClick = (item) => {
    if (item.totalRemainingQuantity === 0) {
      history.push(`/manufacturers-details/${item?.manufacturer?._id}`);
    } else {
      setSelectedWarehouses(item.warehouses || []);
      setShowWarehouseModal(true);
    }
  };



  useEffect(() => {
    fetchOrderDetails();
  }, [_id]);

  const fetchOrderDetails = async () => {
    setLoader(true);
    const payload = {
      orderId: _id?.id,
    };
    try {
      const response = await postRequest(`order/order-details-admin`, payload);
      const data = response.data;
      setUserOrderData(data);
      setuserAllDetails(data?.userDetail);
      console.log("table data", data.bannerData);
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const [sortOrderId, setsortOrderId] = React.useState(null);

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  const selectRow = (item) => {
    console.log({ item });
    setAssingDeliveryData({
      Image: item?.image,
      Title: item?.title,
      categoryId: item?._id,
      show: true,
    });
    deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedProductsData, setSelectedProductsData] = useState([]);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      // Select only products where deliveryStatus is 'pending'
      const pendingIds =
        orderData?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item.productId) || [];

      const filterData =
        orderData?.products
          ?.filter((item) => item.deliveryStatus === "pending")
          .map((item) => item) || [];

      setSelectedProducts(pendingIds);
      setSelectedProductsData(filterData);
    } else {
      setSelectedProducts([]);
    }
  };

  const handleSelectOne = (e, id, item) => {
    setSelectedProducts((prev) => {
      const updatedProducts = prev.includes(id)
        ? prev.filter((pid) => pid !== id)
        : [...prev, id];
      console.log("Updated Selected Products:", updatedProducts);
      return updatedProducts;
    });
    setSelectedProductsData((prev) => {
      if (e.target.checked) {
        return [...prev, item]; // Add product item
      } else {
        return prev.filter((p) => p.productId !== id); // Remove product item
      }
    });
  };

  useEffect(() => {
    console.log(selectedProductsData);
  }, [selectedProductsData]);

  const deliveryAssingOrder = async (_id) => {
    // setLoader(true);
    const payload = {
      type: "specific",
      orderId: orderData?._id,
      deliveryAgentId: _id,
      productIds: selectedProducts,
      warehouseId: orderData?.warehouseId,
    };
    try {
      const response = await postRequest(
        `order/assign-to-delivery-agent`,
        payload
      );
      if (response?.status) {
        fetchOrderDetails();
        // Show success message
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Order successfully assigned to the delivery agent!",
          confirmButtonText: "OK",
          timer: 2000, // Optional: automatically close after 2 seconds
        });
      }
    } catch (error) {
      console.log("Failed to fetch data:", error);
    } finally {
      setLoader(false);
    }
  };

  const cancelOrder = async (_id) => {
    const payload = {
      orderId: _id,
      orderStatus: "cancelled",
    };
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to cancel this order?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    });
    if (result.isConfirmed) {
      const res = await postRequest("order/admin-update-order-status", payload);
      if (res.status) {
        Swal.fire("Cancelled!", "The order has been cancelled.", "success");
        fetchOrderDetails();
      } else {
        Swal.fire("Error!", "Something went wrong.", "error");
        setLoader(false);
      }
    } else {
      Swal.fire("Cancelled", "The order was not cancelled.", "info");
    }
  };

  const closeModalDeleveryAgent = () => {
    setModel(false);
  };

  const PaymentOrderStatus = async (newStatus) => {
    const payload = {
      orderId: orderData?._id,
      paymentStatus: newStatus, // Accepts dynamic status
    };

    const confirmationMessage =
      newStatus === "Cancelled"
        ? {
          title: "Are you sure?",
          text: "Do you want to cancel this Payment?",
          confirmText: "Yes, cancel it!",
          successMessage: "The Payment has been cancelled.",
        }
        : {
          title: "Are you sure?",
          text: "Are you sure you want to approve this order payment?",
          confirmText: "Yes, mark as approve!",
          successMessage: "The order has been marked as approve.",
        };

    const result = await Swal.fire({
      title: confirmationMessage.title,
      text: confirmationMessage.text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: confirmationMessage.confirmText,
      cancelButtonText: "No, go back",
    });

    if (result.isConfirmed) {
      const res = await postRequest("order/update-payment-status", payload);
      if (res.status) {
        Swal.fire("Success!", confirmationMessage.successMessage, "success");
        fetchOrderDetails(); // Refresh the order list
      } else {
        Swal.fire("Error!", "Something went wrong.", "error");
        setLoader(false);
      }
    } else {
      Swal.fire("Cancelled", "No changes were made.", "info");
    }
  };

  const [openLightboxQR, setOpenLightboxQR] = useState(false);
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const qrCodeRef = useRef(null);

  const generateQRDataUrl = () => {
    if (!qrCodeRef.current) return "";

    const svgElement = qrCodeRef.current.querySelector("svg");
    if (!svgElement) return "";

    // Clone the SVG to avoid modifying the original
    const svgClone = svgElement.cloneNode(true);

    // Set explicit width/height for the clone
    svgClone.setAttribute("width", "512px");
    svgClone.setAttribute("height", "512px");

    const svgString = new XMLSerializer().serializeToString(svgClone);
    const svgBlob = new Blob([svgString], {
      type: "image/svg+xml;charset=utf-8",
    });
    return URL.createObjectURL(svgBlob);
  };

  const handlePreviewClick = (_id) => {
    const qrData = JSON.stringify({
      order_id: orderData?._id,
      product_id: _id,
      status: "pickup",
    });
    setOrderId(qrData);
    setTimeout(() => {
      const dataUrl = generateQRDataUrl();
      setQrCodeDataUrl(dataUrl);
      setOpenLightboxQR(true);
    }, 100);
  };

  // Clean up object URLs when component unmounts
  React.useEffect(() => {
    return () => {
      if (qrCodeDataUrl) {
        URL.revokeObjectURL(qrCodeDataUrl);
      }
    };
  }, [qrCodeDataUrl]);

  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Order Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Order Management</li>:{" "}
              <li className="breadcrumb-item">User Order details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>
              <div className="profile-image">
                <img
                  src={
                    userAllDetails?.image
                      ? userAllDetails?.image
                      : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.first_name +
                      " " +
                      userAllDetails?.last_name
                      }`
                  }
                  onClick={() =>
                    showLightBox(
                      userAllDetails?.image
                        ? userAllDetails?.image
                        : `https://ui-avatars.com/api/?background=random&name=${userAllDetails?.first_name +
                        " " +
                        userAllDetails?.last_name
                        }`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst mt-3">
                    {" "}
                    <h3>
                      {" "}
                      {userAllDetails?.first_name +
                        " " +
                        userAllDetails?.last_name}{" "}
                    </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        User Type:{" "}
                        <span>
                          {" "}
                          {orderData?.userDetail?.type === "user" ? (
                            <>SME</>
                          ) : (
                            <>Informal Retailer</>
                          )}
                        </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{userAllDetails?.email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Mobile No. <span> {userAllDetails?.mobile} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Gender: <span> {userAllDetails?.gender} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country: <span> {userAllDetails?.country} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Country Code:{" "}
                        <span> {userAllDetails?.country_code} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Created At:
                        <span> {formatDate(userAllDetails?.createdAt)}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            <Col md="12">
              <div className="card">
                <div className="card-body ">
                  <div
                    className="order-info"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "22px",
                    }}
                  >
                    <h3>Payment Overview</h3>
                    <div className="d-flex gap-2">
                      {orderData?.paymentStatus == "Unpaid" ? (
                        orderData?.paymentRefNumber !== "" &&
                          orderData?.paymentMethod == "bankDeposit" ? (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                PaymentOrderStatus("Paid");
                              }}
                            >
                              Mark as Approve
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => PaymentOrderStatus("Cancelled")}
                            >
                              Cancel Payment
                            </button>
                          </>
                        ) : (
                          <div className="status-order">
                            <h5
                              style={
                                orderData?.deliveryStatus === "Cancelled"
                                  ? { color: "#ec536c" }
                                  : orderData?.deliveryStatus === "failed"
                                    ? { color: "#ec536c" }
                                    : orderData?.deliveryStatus === "Unpaid"
                                      ? { color: "#ec536c" }
                                      : orderData?.deliveryStatus === "Paid"
                                        ? { color: "rgb(255, 193, 7)" }
                                        : { color: "#4caf50" }
                              }
                            >
                              {/* {orderData?.paymentStatus} */}
                            </h5>
                          </div>
                        )
                      ) : (
                        <>
                          {orderData?.orderStatus === "cancelled" ? (
                            <h5 style={{ color: "#ec536c" }}></h5>
                          ) : (
                            <div className="status-order">
                              <h5
                                style={
                                  orderData?.deliveryStatus === "cancelled"
                                    ? { color: "#ec536c" }
                                    : orderData?.deliveryStatus === "failed"
                                      ? { color: "#ec536c" }
                                      : orderData?.deliveryStatus === "pending"
                                        ? { color: "#ec536c" }
                                        : orderData?.deliveryStatus === "assigned"
                                          ? { color: "rgb(255, 193, 7)" }
                                          : { color: "#4caf50" }
                                }
                              >
                                {orderData?.deliveryStatus === "cancelled" ||
                                  orderData?.deliveryStatus === "failed" ? (
                                  <>
                                    <span className="text-danger text-warning-delivery">
                                      Delivery Canceled by Agent
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        setsortOrderId(orderData?._id);
                                        toggleModel();
                                      }}
                                    >
                                      Reassign Agent
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </h5>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>

                  <div className="row" style={{ textTransform: "capitalize" }}>
                    <div className="col-md-2 fst py-1">
                      <p className="mb-0">
                        Payment Status.{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.paymentStatus === "completed" ||
                                orderData?.paymentStatus === "Paid"
                                ? "#4caf50"
                                : orderData?.paymentStatus === "Cancelled"
                                  ? "#ec536c"
                                  : "#FF9800",
                          }}
                        >
                          {orderData?.paymentStatus}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Payment Method:{" "}
                        <span className="status-bg-span">
                          {orderData?.paymentMethod}{" "}
                        </span>
                      </p>
                    </div>

                    {orderData?.paymentRefNumber !== "" ? (
                      <div className="col-md-3 fst py-1">
                        <p className="mb-0">
                          Payment Ref Number:
                          <span className="status-bg-span">
                            {orderData?.paymentRefNumber}
                          </span>
                        </p>
                      </div>
                    ) : (
                      <div className="col-md-3 fst py-1">
                        <p className="mb-0">
                          Payment Ref Number:{" "}
                          <span className="status-bg-span">Not Available</span>
                        </p>
                      </div>
                    )}

                    <div className="col-md-4 fst d-flex gap-2 py-1">
                      <p className="mb-0">Payment Receipt:</p>
                      <div
                        className=" d-flex gap-2 align-items-center"
                        style={{ marginTop: "-14px" }}
                      >
                        {orderData?.depositProof?.map((item) => {
                          return (
                            <div style={{ cursor: "pointer" }}>
                              <img
                                onClick={() => showLightBox(item)}
                                src={item}
                                width={"40px"}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col md="12">
              <div className="card">
                <div className="card-body ">
                  <div
                    className="order-info"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "22px",
                    }}
                  >
                    <h3>Order Overview</h3>
                    <div className="d-flex gap-2">
                      {orderData?.orderStatus === "pending" ? (
                        orderData?.deliveryStatus === "pending" ? (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => {
                                setsortOrderId(orderData?._id);
                                toggleModel();
                              }}
                            >
                              Confirm Delivery
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger"
                              onClick={() => cancelOrder(orderData?._id)}
                            >
                              Cancel Order
                            </button>
                          </>
                        ) : (
                          <div className="status-order">
                            <h5
                              style={
                                orderData?.deliveryStatus === "cancelled"
                                  ? { color: "#ec536c" }
                                  : orderData?.deliveryStatus === "failed"
                                    ? { color: "#ec536c" }
                                    : orderData?.deliveryStatus === "pending"
                                      ? { color: "#ec536c" }
                                      : orderData?.deliveryStatus === "assigned"
                                        ? { color: "rgb(255, 193, 7)" }
                                        : { color: "#4caf50" }
                              }
                            >
                              {orderData?.deliveryStatus === "cancelled" ||
                                orderData?.deliveryStatus === "failed" ? (
                                <>
                                  <div>
                                    <span className="text-danger text-warning-delivery">
                                      Delivery Canceled by Agent
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        setsortOrderId(orderData?._id);
                                        toggleModel();
                                      }}
                                    >
                                      Reassign Agent
                                    </button>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </h5>
                          </div>
                        )
                      ) : (
                        <>
                          {orderData?.orderStatus === "cancelled" ? (
                            <h5 style={{ color: "#ec536c" }}></h5>
                          ) : (
                            <div className="status-order">
                              <h5
                                style={
                                  orderData?.deliveryStatus === "cancelled"
                                    ? { color: "#ec536c" }
                                    : orderData?.deliveryStatus === "failed"
                                      ? { color: "#ec536c" }
                                      : orderData?.deliveryStatus === "pending"
                                        ? { color: "#ec536c" }
                                        : orderData?.deliveryStatus === "assigned"
                                          ? { color: "rgb(255, 193, 7)" }
                                          : { color: "#4caf50" }
                                }
                              >
                                {orderData?.deliveryStatus === "cancelled" ||
                                  orderData?.deliveryStatus === "failed" ? (
                                  <>
                                    <span className="text-danger text-warning-delivery">
                                      Delivery Canceled by Agent
                                    </span>
                                    <button
                                      type="button"
                                      className="btn btn-primary"
                                      onClick={() => {
                                        setsortOrderId(orderData?._id);
                                        toggleModel();
                                      }}
                                    >
                                      Reassign Agent
                                    </button>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </h5>
                            </div>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="row" style={{ textTransform: "capitalize" }}>
                    {/* <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Order Status: <span className="status-bg-span" style={{
                          color:
                            orderData?.orderStatus === 'pending'
                              ? '#FF9800'
                              : orderData?.orderStatus === 'cancelled'
                                ? '#ec536c'
                                : '#4caf50',
                        }}>
                          {orderData?.orderStatus}
                        </span>
                      </p>
                    </div> */}

                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Order Status:{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.orderStatus === "pending"
                                ? "#FF9800"
                                : orderData?.orderStatus === "cancelled"
                                  ? "#ec536c"
                                  : "#4caf50",
                          }}
                        >
                          {orderData?.orderStatus}
                        </span>
                        {orderData?.orderStatus === "pending" && (
                          <span className="d-block small text-muted">
                            Confirm the delivery and assign delivery agent to
                            confirm the order
                          </span>
                        )}
                        {orderData?.orderStatus === "confirmed" && (
                          <span className="d-block small text-muted">
                            Waiting for delivery agent to pick up the order
                          </span>
                        )}
                        {orderData?.orderStatus === "delivered" && (
                          <span className="d-block small text-muted">
                            Order has been delivered to the user
                          </span>
                        )}
                      </p>
                    </div>
                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Payment Status.{" "}
                        <span
                          className="status-bg-span"
                          style={{
                            color:
                              orderData?.paymentStatus === "completed" ||
                                orderData?.paymentStatus === "Paid"
                                ? "#4caf50"
                                : orderData?.paymentStatus === "Cancelled"
                                  ? "#ec536c"
                                  : "#FF9800",
                          }}
                        >
                          {orderData?.paymentStatus}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Payment Method:{" "}
                        <span className="status-bg-span">
                          {orderData?.paymentMethod}{" "}
                        </span>
                      </p>
                    </div>
                    {/* <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Delivery Status:{" "}
                        <span
                          className="status-bg-span"
                          style={
                            orderData?.deliveryStatus === "cancelled"
                              ? { color: "#ec536c" }
                              : orderData?.deliveryStatus === "failed"
                              ? { color: "#ec536c" }
                              : orderData?.deliveryStatus === "pending"
                              ? { color: "#ec536c" }
                              : orderData?.deliveryStatus === "assigned"
                              ? { color: "#FF9800" }
                              : { color: "#4caf50" }
                          }
                        >
                          {" "}
                          {orderData?.deliveryStatus}{" "}
                        </span>
                      </p>
                    </div> */}

                    <div className="col-md-3 fst py-1">
                      <p className="mb-0">
                        Delivery Status:{" "}
                        <span
                          className="status-bg-span"
                          style={
                            orderData?.deliveryStatus === "cancelled"
                              ? { color: "#ec536c" }
                              : orderData?.deliveryStatus === "failed"
                                ? { color: "#ec536c" }
                                : orderData?.deliveryStatus === "pending"
                                  ? { color: "#ec536c" }
                                  : orderData?.deliveryStatus === "assigned"
                                    ? { color: "#FF9800" }
                                    : { color: "#4caf50" }
                          }
                        >
                          {orderData?.deliveryStatus}
                        </span>
                        {orderData?.deliveryStatus === "assigned" && (
                          <span className="d-block small text-muted">
                            Waiting for the delivery agent to pickup the order
                          </span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="exTab2"
                className="twitter-like-tabs2"
                style={{ background: "#ffff" }}
              >
                <ul
                  className="nav nav-pills"
                  style={{ width: "480px", display: "contents" }}
                >
                  <li className="active">
                    <a href="#shopes" data-toggle="tab">
                      {" "}
                      Orders{" "}
                    </a>
                  </li>

                  <li>
                    <a href="#Order" data-toggle="tab">
                      {" "}
                      {orderData?.deliveryAddress?.addrestype === "shop" ? (
                        "Shop Shipping Address"
                      ) : (
                        <>Shipping Address </>
                      )}
                    </a>
                  </li>
                  {/* {orderData?.trackingDetails &&
                    <li>
                      <a href="#Assigned" data-toggle="tab">
                        {" "}
                        Assigned Agent Detail
                      </a>
                    </li>
                  } */}
                </ul>
              </div>
            </Col>
            <Col md="12" className="mt-3">
              <div className="card">
                <div className="card-body">
                  <div className="tab-content clearfix">
                    <div
                      className="tab-pane active show padded-tab"
                      id="shopes"
                    >
                      {/* <ShoplistTable userId={userAllDetails?._id} /> */}
                      <div className="mb-2 mt-1 text-end">
                        {selectedProducts?.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleModel();
                            }}
                          >
                            Assign Delivery
                          </button>
                        )}
                      </div>
                      <table className="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>
                              <input
                                style={{
                                  height: "20px",
                                  width: "21px",
                                  cursor: "pointer",
                                }}
                                type="checkbox"
                                onChange={handleSelectAll}
                                checked={
                                  orderData?.products?.length > 0 &&
                                  selectedProducts.length ===
                                  orderData?.products?.filter(
                                    (item) =>
                                      item.deliveryStatus === "pending"
                                  ).length &&
                                  selectedProducts.length > 0
                                }
                              />
                            </th>
                            <th tabIndex={0}>S.NO</th>
                            <th tabIndex={0}>Manufacturer Info</th>
                            <th tabIndex={0}>Product Image</th>
                            <th tabIndex={0}>Product Name</th>
                            {/* <th tabIndex={0}>Description	</th> */}
                            <th tabIndex={0}>Quantity</th>
                            <th tabIndex={0}>Price</th>
                            <th tabIndex={0}>Total Amount</th>
                            {/* <th tabIndex={0}>Inventory Qty</th> */}
                             <th tabIndex={0}>Total Remaining Qty</th>
                            <th tabIndex={0}>Delivery Status</th>

                           



                          </tr>
                        </thead>
                        <tbody>
                          {orderData?.products?.map((item, index) => {
                            const isFirstSelected =
                              selectedProducts.length > 0 &&
                              selectedProducts[0] === item.productId;
                            return (
                              <>
                                <tr key={index}>
                                  <td>
                                    {item?.deliveryStatus === "pending" && (
                                      <input
                                        style={{
                                          height: "20px",
                                          width: "20px",
                                          cursor: "pointer",
                                        }}
                                        type="checkbox"
                                        checked={selectedProducts.includes(
                                          item.productId
                                        )}
                                        onChange={(e) =>
                                          handleSelectOne(
                                            e,
                                            item.productId,
                                            item
                                          )
                                        }
                                      />
                                    )}
                                  </td>
                                  <td>{index + 1}</td>
                                  <td>
                                    <div className="d-flex gap-2 align-items-center">
                                      <Link
                                        to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                      >
                                        <div style={{ width: "50px" }}>
                                          <img
                                            src={item?.manufacturer?.logo}
                                            width="50px"
                                          />
                                        </div>
                                      </Link>
                                      <div className="flex-product text-start">
                                        <Link
                                          to={`/manufacturers-details/${item?.manufacturer?._id}`}
                                          className="mb-0"
                                        >
                                          {item?.manufacturer?.companyName}
                                        </Link>
                                        {/* <p className="mb-0">{item?.manufacturer?.mobile}, </p> */}
                                        <p className="mb-0">
                                          {item?.manufacturer?.address}
                                        </p>
                                      </div>
                                    </div>
                                  </td>
                                  <td>
                                    <img
                                      src={item?.images?.[0]}
                                      alt="Not found Product"
                                      width="50px"
                                    />
                                  </td>

                                  <td>{item?.name}</td>
                                  {/* <td style={{ width: '254px' }}>{item?.description}</td> */}
                                  <td>{item?.quantity}</td>
                                  <td>${item?.price}</td>
                                  <td>${item?.totalPrice}</td>
                                  {/* <td>{item?.remainingQuantity}</td> */}
                                                                    <td>
                                    <span>{item?.totalRemainingQuantity}</span>
                                    <br />
                                    <button
                                      type="button"
                                      className="btn btn-primary w-md"
                                      onClick={() => handleWarehouseClick(item)}
                                    >
                                      {item.totalRemainingQuantity === 0 ? "View Manufacturer" : "View Warehouses"}
                                    </button>
                                  </td>
                                  <td>
                                    {item?.deliveryStatus === "pending" ? (
                                      <button
                                        disabled={
                                          !isFirstSelected ||
                                          selectedProducts?.length > 1
                                        }
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => {
                                          // setsortOrderId(item?._id);
                                          toggleModel();
                                        }}
                                      >
                                        Assign Delivery
                                      </button>
                                    ) : (
                                      <div>
                                        <div
                                          ref={qrCodeRef}
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-block",
                                          }}
                                          onClick={() =>
                                            handlePreviewClick(item?.productId)
                                          }
                                        >
                                          <QRCodeSVG
                                            value={orderId}
                                            size={40}
                                            level="H"
                                            includeMargin={true}
                                          />
                                          <p className="mb-0">
                                            Click to enlarge
                                          </p>
                                        </div>

                                        {/* Lightbox */}
                                        {openLightboxQR && qrCodeDataUrl && (
                                          <Lightbox
                                            mainSrc={qrCodeDataUrl}
                                            onCloseRequest={() =>
                                              setOpenLightboxQR(false)
                                            }
                                            enableZoom={true}
                                          />
                                        )}
                                        <hr />
                                        <Link
                                          to={{
                                            pathname:
                                              "/delivery-agents-details",
                                            state: item?.deliveryAgent,
                                          }}
                                          className="d-flex align-items-center justify-content-start text-start"
                                          style={{ gap: "10px" }}
                                        >
                                          <span>
                                            <img
                                              src={item?.deliveryAgent?.image}
                                              width="50px"
                                            />
                                          </span>
                                          <div style={{ color: "#696464" }}>
                                            <span>
                                              Name :{" "}
                                              {item?.deliveryAgent?.first_name +
                                                item?.deliveryAgent?.last_name}
                                            </span>
                                            <br />
                                            <span>
                                              {" "}
                                              {item?.deliveryAgent?.email}
                                            </span>
                                            <br />
                                            <span>
                                              Status :{" "}
                                              <span
                                                className="status-bg-span text-capitalize"
                                                style={
                                                  item?.deliveryStatus ===
                                                    "cancelled"
                                                    ? { color: "#ec536c" }
                                                    : item?.deliveryStatus ===
                                                      "failed"
                                                      ? { color: "#ec536c" }
                                                      : item?.deliveryStatus ===
                                                        "pending"
                                                        ? { color: "#FF9800" }
                                                        : item?.deliveryStatus ===
                                                          "assigned"
                                                          ? { color: "#FF9800" }
                                                          : { color: "#4caf50" }
                                                }
                                              >
                                                {" "}
                                                {item?.deliveryStatus}{" "}
                                              </span>
                                            </span>
                                          </div>
                                        </Link>
                                      </div>
                                    )}
                                  </td>





                                  {/* <td> <button type="button" className=" btn btn-info  mx-2">
                              {" "}
                              <Link
                                to={{
                                  pathname: `/product-details`,
                                  state: { item },
                                }}
                              >
                                {" "}
                                <i class="fal fa-eye text-light"></i>
                              </Link>{" "}
                            </button></td> */}
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    <div className="tab-pane padded-tab" id="Order">
                      <div className="custom-card">
                        {/* <div
                      className="cover-image"
                      style={{ backgroundColor: "rgb(29, 155, 240)" }}
                    /> */}
                        {orderData?.deliveryAddress?.addrestype === "shop" ? (
                          <>
                            <div className="profile-images">
                              <img
                                src={
                                  orderData?.shopDetails?.image
                                    ? orderData?.shopDetails?.image
                                    : `https://ui-avatars.com/api/?background=random&name=${orderData?.shopDetails?.shopName}`
                                }
                                onClick={() =>
                                  showLightBox(
                                    orderData?.shopDetails?.image
                                      ? orderData?.shopDetails?.image
                                      : `https://ui-avatars.com/api/?background=random&name=${orderData?.shopDetails?.shopName}`
                                  )
                                }
                                alt="Image Not Available"
                              />
                            </div>
                            <br />
                            <div className="row my-2 py-2">
                              <div
                                className="userinfo col-md-12 "
                                style={{ paddingLeft: 20 }}
                              >
                                <div className="fst">
                                  {" "}
                                  <h3>
                                    {" "}
                                    {orderData?.shopDetails?.shopName}{" "}
                                  </h3>{" "}
                                </div>
                                <div className="row">
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Email:{" "}
                                      <span>
                                        {orderData?.shopDetails?.email}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Mobile No.:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.phone}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      City:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.city}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.shopDetails?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      State:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.state}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Post Code:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.shopDetails?.postCode}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Landmark
                                      <span>
                                        {orderData?.shopDetails?.landmark}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      Address Line 1&nbsp;&nbsp;
                                      <span>
                                        {state?.shopDetails?.addressLine1}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Address Line 2&nbsp;&nbsp;
                                      <span>
                                        {" "}
                                        {state?.shopDetails?.addressLine2}{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </>
                        ) : (
                          <>
                            <div className="row my-2 py-2">
                              <div
                                className="userinfo col-md-12 "
                                style={{ paddingLeft: 20 }}
                              >
                                <div className="row">
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Address Type:{" "}
                                      <span>
                                        {orderData?.deliveryAddress?.addrestype}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Email:{" "}
                                      <span>
                                        {orderData?.deliveryAddress?.email}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Mobile No.:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.phone}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      City:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.city}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.deliveryAddress?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      State:{" "}
                                      <span>
                                        {" "}
                                        {orderData?.deliveryAddress?.state}{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    {" "}
                                    <p>
                                      {" "}
                                      Post Code:{" "}
                                      <span>
                                        {" "}
                                        {
                                          orderData?.deliveryAddress?.postCode
                                        }{" "}
                                      </span>{" "}
                                    </p>{" "}
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Landmark
                                      <span>
                                        {orderData?.deliveryAddress?.landmark}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      Address Line 1&nbsp;&nbsp;
                                      <span>
                                        {state?.deliveryAddress?.addressLine1}
                                      </span>
                                    </p>
                                  </div>
                                  <div className="col-md-4 fst py-1">
                                    <p>
                                      {" "}
                                      Address Line 2&nbsp;&nbsp;
                                      <span>
                                        {" "}
                                        {
                                          state?.deliveryAddress?.addressLine2
                                        }{" "}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="tab-pane padded-tab" id="Assigned">
                      <div className="custom-card card">
                        <div className="profile-images">
                          <img
                            src={
                              orderData?.trackingDetails?.image
                                ? orderData?.trackingDetails?.image
                                : `https://ui-avatars.com/api/?background=random&name=${orderData?.trackingDetails?.first_name +
                                orderData?.trackingDetails?.last_name
                                }`
                            }
                            onClick={() =>
                              showLightBox(
                                orderData?.trackingDetails?.image
                                  ? orderData?.trackingDetails?.image
                                  : $`https://ui-avatars.com/api/?background=random&name=${orderData?.trackingDetails?.first_name +
                                    orderData?.trackingDetails?.last_name
                                    }`
                              )
                            }
                            alt="Image Not Available"
                            width="70px"
                          />
                        </div>
                        <br />
                        <div className="row my-2 py-2">
                          <div
                            className="userinfo col-md-12 "
                            style={{ paddingLeft: 20 }}
                          >
                            <div className="fst">
                              {" "}
                              <h3>
                                {" "}
                                {orderData?.trackingDetails?.first_name}{" "}
                                {orderData?.trackingDetails?.last_name}{" "}
                              </h3>{" "}
                            </div>
                            <div className="row">
                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Email:{" "}
                                  <span>
                                    {orderData?.trackingDetails?.email}
                                  </span>{" "}
                                </p>{" "}
                              </div>
                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Mobile No.:{" "}
                                  <span>
                                    {" "}
                                    {orderData?.trackingDetails?.phone}{" "}
                                  </span>{" "}
                                </p>{" "}
                              </div>

                              <div className="col-md-4 fst py-1">
                                {" "}
                                <p>
                                  {" "}
                                  Assigned Date.:{" "}
                                  <span>
                                    {moment(orderData?.updatedAt).format(
                                      "DD-MM-YYYY hh:mm"
                                    )}
                                  </span>{" "}
                                </p>{" "}
                              </div>

                              {/* <div className="col-md-4 fst py-1">
                            {" "}
                            <p>
                              {" "}
                              Status: <span> {orderData?.shopDetails?.state} </span>{" "}
                            </p>{" "}
                          </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </>
        )}

        <DeliveryAgents
          show={model}
          selectedProductsData={selectedProductsData}
          orderId={_id?.id}
          orderInfo={{
            orderId: _id?.id,
            userName:
              userAllDetails?.first_name + " " + userAllDetails?.last_name,
            orderAddress:
              (orderData?.deliveryAddress?.addressLine1 || "") +
              " " +
              (orderData?.deliveryAddress?.addressLine2 || "") +
              " " +
              (orderData?.deliveryAddress?.city || ""),
            userType: orderData?.userDetail?.type,
            orderStatus: orderData?.orderStatus,
            paymentStatus: orderData?.paymentStatus,
            grandTotal: orderData?.grandTotal,
            orderDate: orderData?.createdAt,
            warehouseId: orderData?.warehouseId,
          }}
          closeModal={closeModalDeleveryAgent}
          selectRow={selectRow}
        />

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />


        )}

        <Modal isOpen={showWarehouseModal} toggle={() => setShowWarehouseModal(false)} size="md">
          <div className="modal-header">
            <h5 className="modal-title">Warehouses with Inventory</h5>
            <button type="button" className="btn-close" onClick={() => setShowWarehouseModal(false)}></button>
          </div>
          <div className="modal-body">
            {selectedWarehouses && selectedWarehouses.length > 0 ? (
              <table className="table table-striped table-bordered">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Warehouse Name</th>
                    <th>Remaining Quantity</th>
                    {selectedWarehouses.some(w => w.block) && <th>Block</th>}
                  </tr>
                </thead>
                <tbody>
                  {selectedWarehouses.map((wh, index) => (
                    <tr key={wh.warehouseId}>
                      <td>{index + 1}</td>
                      <td>{wh.warehouseName}</td>
                      <td>{wh.remainingQuantity}</td>
                      {wh.block && <td>{wh.block}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No warehouse data available for this product.</p>
            )}
          </div>
        </Modal>



      </Row>
      <ToastContainer />{" "}
    </>
  );
}
